import { goodsFormSchemaFromSettings } from '../components/goods/goods-add-sidepanel/goods-add-sidepanel.form.schema';
import { Settings } from '@ct-client';

export const fieldMap = {
    type: {
        field: 'nPartID',
        error: 'generic_order_missing_part'
    },
    costType: {
        field: 'nCostObjectID',
        error: 'generic_order_missing_cost_type'
    },
    quantity: {
        field: 'nQuantity',
        error: 'generic_order_missing_quantity'
    },
    stackability: {
        field: 'nOverrideMaxStackability',
        error: 'generic_order_missing_stackability_override'
    },
    length: {
        field: 'dimensions.fLength',
        error: 'generic_order_missing_length'
    },
    width: {
        field: 'dimensions.fWidth',
        error: 'generic_order_missing_width'
    },
    height: {
        field: 'dimensions.fHeight',
        error: 'generic_order_missing_height'
    },
    grossWeight: {
        field: 'fMassGro',
        error: 'generic_order_missing_weight'
    },
    netWeight: {
        field: 'fMassNet',
        error: 'generic_order_missing_weight'
    },
    description: {
        field: 'sContentDescription',
        error: 'generic_order_missing_description'
    },
    goodsValue: {
        field: 'fValue',
        error: 'generic_order_missing_price'
    },
    dangerous: { // todo: hazardous and dangerous is not the same!
        field: 'bHazard',
        error: 'generic_required_fields_missing' // boolean will always be true/false
    },
    tempControlled: {
        field: 'bTemper',
        error: 'generic_required_fields_missing' // boolean will always be true/false
    },
    answers: {
        field: 'aQuestionAnswers',
        error: 'generic_order_missing_answers'
    }
};

// todo: define model for line
export function validateMatLine(line, settings: Settings): boolean {
    const schema = goodsFormSchemaFromSettings(settings);
    const requiredFields = Object.keys(schema).filter(key => schema[key].required);

    // extracts a nested value from an object e.g: 'a.b' or 'dimensions.fWidth'
    const getValue = (obj: any, str: string) => str.split('.').reduce((o, k) => (o || {})[k], obj);

    for (const field of requiredFields) {
        const value = getValue(line, fieldMap[field].field);
        if (value === null || value === undefined) {
            return fieldMap[field].error;
        }
    }

    return null;
}
